<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  #app{
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-flow: column;
    align-items: center;
    overflow: hidden;
    background: #fafafa;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue